import { identity } from 'ramda'
import React from 'react'

import { FlexCol } from '../structure/FlexGrid'
import { PanelContent } from '../structure/Panel'
import { SmallText, Title } from './Text'
import { useHideOn } from '../../utils/contexts/ResponsiveProvider'
import Separator from '../helpers/Separator'
import { COLORS } from '@btime/constants'

const LabelValueBox = ({ t, label, value, hideOn, labelMinHeight, size, ...props }) => {
  t = t || identity
  if (useHideOn(hideOn)) return false

  return (
    <FlexCol flex={1}>
      <PanelContent mediumPadding>
        <SmallText color={COLORS.dark3} preLine>
          {t(label)}
        </SmallText>

        <Separator weight={2} />

        <Title size={size || 'h4'} noMargin color={COLORS.dark2} {...props}>
          {value}
        </Title>
      </PanelContent>
    </FlexCol>
  )
}

export default LabelValueBox
